<section class="drawer-heading__quote">
	<p class="drawer-heading__quote-contact">{{ contactFullName$ | async }}</p>
	<p class="drawer-heading__quote-version">
		Policy v{{ (quote$ | async)?.productVersion }} -
		{{ (contact$ | async)?.ratingState ?? '' }}
	</p>
	<p class="drawer-heading__quote-brand">
		<strong>Brand:</strong>
		{{ (contact$ | async)?.brand || '&mdash;' }}
	</p>
	<p
		*ngIf="isZoomiesLead"
		class="drawer-heading__quote-brand"
	>
		<strong>Lead:</strong>
		{{ leadDisplay || '&mdash;' }}
	</p>
</section>
